import AbstractOptionList from './AbstractOptionList'
import BsRadio from './BsRadio'

export default {
  functional: true,
  render (h, {data, children}) {
    return h(AbstractOptionList, {...data, props: {...data.props, component: BsRadio}}, children)
  }
}
